import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Select, Row, Col, notification } from 'antd';
import JoinModalWrapper from './styles/join-modal.style';
import PhoneInput from 'react-phone-input-2';
import * as TherapistActions from '../../actions/therapist';
import 'react-phone-input-2/lib/style.css';

const { Option } = Select;

class JoinModal extends Component {
    constructor(props){
        super(props);
        this.state={
            phone: "",
            showVisitOverview: true
        }
    }
    goPreviousRoom = () => {
        const { callDetails } = this.props;
        window.location.href = ("/videoRoom/" + callDetails.therapistRoom);
    }

    remainInCurrentRoomRoom = () => {
        
        const { dispatch } =this.props;
		const callId = window.localStorage.getItem("patientCallId");
		const status = "End Call"
		dispatch(TherapistActions.changeCallStatus({callId, status}, () => {

			window.localStorage.removeItem("therapistCallId");
			window.localStorage.removeItem('patientCallId');
			window.sessionStorage.removeItem('twilioPatientToken');
            window.sessionStorage.setItem('therapistConnecting', "no");
            window.sessionStorage.setItem('patientConnecting', "no");

            window.location.reload();
		}))
    }


    render() {
        const { visible, onCancel, callDetails, currentRoom } = this.props;

        return (
        
                <Modal
                        width={445}
                        className="inviteModal"
                        overlayClassName="inviteModal1"
                        visible={visible}
                        onCancel={onCancel}
                        centered
                        footer=""
                        >
                            <JoinModalWrapper>
                         <div className="invite-form-wrapper">
                             <header>
                             <h1>Ongoing Video Room</h1>   
                             <h2>Seems you already have an ongoing call on another video room. </h2>
                              <h2>Do you want to go back to <strong>{callDetails.therapistRoom}'s</strong> video room or close it and join <strong>{currentRoom}'s</strong> video room?</h2>
                             </header>
                             <div className="button-wrapper">
                             <Row type="flex" justify="center">
                                 <Col span={24}>
                                 <button className="button-action" onClick={this.goPreviousRoom}>GO BACK TO {callDetails.therapistRoom}'S VIDEO ROOM </button>
                                 </Col>
                                 <Col span={24}>
                                 <button className="button-action" onClick={this.remainInCurrentRoomRoom}>CLOSE AND JOIN {currentRoom}'S VIDEO ROOM</button>
                                 </Col>
                             </Row>
                             </div>
                         </div>
                          </JoinModalWrapper>
                 </Modal>
                     
        );
    }
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(JoinModal);
